(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notify-me-form"] && !Shopify.designMode) return;
  try {
    (function () {
    const KLAVIYO_REVISION = '2024-10-15';

    function init(form) {
      if (form.dataset.notifyMeBound === '1') return;
      form.dataset.notifyMeBound = '1';

      const submitBtn = form.querySelector('[data-notify-me-submit]');
      const successEl = form.querySelector('.notify-me__msg--success');
      const errorEl = form.querySelector('[data-notify-me-error]');
      const phoneInput = form.querySelector('input[name="phone"]');
      const smsCheckbox = form.querySelector('[data-sms-consent]');

      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }

      function clearError() {
        if (!errorEl) return;
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      function setBusy(busy) {
        if (!submitBtn) return;
        submitBtn.disabled = busy;
        submitBtn.dataset.state = busy ? 'busy' : '';
      }

      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        clearError();

        const fd = new FormData(form);
        const email = (fd.get('email') || '').toString().trim();
        const firstName = (fd.get('first_name') || '').toString().trim();
        const phoneRaw = (fd.get('phone') || '').toString().trim();
        const smsConsent = !!fd.get('sms_consent');

        if (!email) {
          showError('Please enter your email.');
          return;
        }
        if (smsConsent && !phoneRaw) {
          showError('Add a phone number, or uncheck the text-message option.');
          return;
        }

        const companyId = form.dataset.klaviyoCompanyId;
        const listId = form.dataset.klaviyoListId;
        if (!companyId || !listId) {
          showError('Notification signup is not configured. Please try again later.');
          return;
        }

        const courseHandle = form.dataset.productHandle || '';
        const courseTitle = form.dataset.productTitle || '';
        const courseId = form.dataset.productId || '';

        const profileAttrs = {
          email: email,
          properties: {
            last_course_interest_handle: courseHandle,
            last_course_interest_title: courseTitle,
            last_course_interest_at: new Date().toISOString(),
          },
          subscriptions: {
            email: { marketing: { consent: 'SUBSCRIBED' } },
          },
        };

        if (firstName) profileAttrs.first_name = firstName;

        if (phoneRaw) {
          profileAttrs.phone_number = phoneRaw;
          if (smsConsent) {
            profileAttrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
          }
        }

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Course Notify: ' + courseHandle,
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttrs,
                },
              },
            },
            relationships: {
              list: {
                data: { type: 'list', id: listId },
              },
            },
          },
        };

        setBusy(true);

        try {
          const url =
            'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId);
          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: KLAVIYO_REVISION,
            },
            body: JSON.stringify(payload),
          });

          if (!res.ok) {
            let detail = 'Could not save your signup.';
            try {
              const body = await res.json();
              if (body && body.errors && body.errors[0] && body.errors[0].detail) {
                detail = body.errors[0].detail;
              }
            } catch (e) {
              /* ignore */
            }
            throw new Error(detail);
          }

          if (window._learnq) {
            const identifyTraits = { $email: email };
            if (firstName) identifyTraits.$first_name = firstName;
            if (phoneRaw && smsConsent) identifyTraits.$phone_number = phoneRaw;
            window._learnq.push(['identify', identifyTraits]);
            window._learnq.push([
              'track',
              'Showed Interest in Course',
              {
                course_handle: courseHandle,
                course_title: courseTitle,
                course_id: courseId,
                phone_provided: !!phoneRaw,
                sms_consent: smsConsent,
              },
            ]);
          }

          form.dataset.state = 'success';
          if (successEl) successEl.hidden = false;
        } catch (err) {
          showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
        } finally {
          setBusy(false);
        }
      });

      // Make the SMS checkbox require a phone visually (no hard requirement on submit; we check above)
      if (smsCheckbox && phoneInput) {
        smsCheckbox.addEventListener('change', function () {
          if (smsCheckbox.checked) {
            phoneInput.setAttribute('required', '');
            phoneInput.focus();
          } else {
            phoneInput.removeAttribute('required');
          }
        });
      }
    }

    function bindAll(root) {
      const scope = root || document;
      scope.querySelectorAll('[data-notify-me-form]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        bindAll();
      });
    } else {
      bindAll();
    }

    // Re-bind in case section is re-rendered (theme editor, soft navigation)
    document.addEventListener('shopify:section:load', function (e) {
      bindAll(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
